var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12.6183 11.0734C12.5705 10.9265 12.4888 10.793 12.3797 10.6836L11.4077 9.7092C11.2689 9.56877 11.0907 9.47375 10.8967 9.43667C10.7028 9.3996 10.5022 9.42221 10.3213 9.50153C10.1181 9.58856 9.93259 9.71209 9.77393 9.86599C8.66189 10.979 5.0215 7.33858 6.13401 6.22607C6.28737 6.06743 6.41041 5.88207 6.49707 5.67915C6.57626 5.49829 6.5988 5.29768 6.56173 5.10375C6.52466 4.90983 6.42972 4.73168 6.28941 4.59278L5.31643 3.62026C5.20701 3.51122 5.07346 3.42948 4.92657 3.38166C4.77969 3.33384 4.62361 3.32128 4.47097 3.345C4.31833 3.36872 4.17343 3.42806 4.04798 3.5182C3.92254 3.60834 3.82009 3.72676 3.74893 3.86386C3.33018 4.64734 3.22316 5.56018 3.44933 6.41927C4.02332 8.69935 7.30065 11.9767 9.58073 12.5507C10.4398 12.7768 11.3527 12.6698 12.1361 12.2511C12.2732 12.1799 12.3917 12.0775 12.4818 11.952C12.5719 11.8266 12.6313 11.6817 12.655 11.529C12.6787 11.3764 12.6662 11.2203 12.6183 11.0734Z",
    fill: "#B6C700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialIcon);
export default __webpack_public_path__ + "static/media/dial-icon.3dd055f27a4102ddde2b5dee90b84bf8.svg";
export { ForwardRef as ReactComponent };